<form class="form" [formGroup]="formGroup" (ngSubmit)="onSubmit($event)">
  <app-scroll-view class="scroll-view">
    <section class="section-form">
      <div class="field-set">
        <label label>STATUS</label>

        <app-select-box
          formControlName="status"
          [items]="statusList"
          displayExpr="description"
          valueExpr="id"
          [showErrorEnabled]="false"
          [readOnly]="true"
          [appBlockModalDrag]="!(isMobileModeObservable | async)"
        ></app-select-box>
      </div>

      <div class="field-set">
        <label label>TIPO DE OCORRÊNCIA*</label>

        <app-select-box
          formControlName="type"
          [items]="typeList"
          displayExpr="description"
          valueExpr="id"
          [showClearButton]="false"
          [showErrorEnabled]="false"
          [readOnly]="isEditMode"
          [appBlockModalDrag]="!(isMobileModeObservable | async)"
        ></app-select-box>
      </div>

      <div class="field-set">
        <label label>OBSERVAÇÕES</label>

        <app-text-area
          formControlName="observation"
          [rows]="3"
          resize="none"
          [showErrorEnabled]="false"
          [readOnly]="isEditMode"
          [appBlockModalDrag]="!(isMobileModeObservable | async)"
        ></app-text-area>
      </div>
    </section>

    <section class="section-form section-list">
      <ng-template
        [ngTemplateOutlet]="sectionListTpl"
        [ngTemplateOutletContext]="notesSectionListContext"
      ></ng-template>
    </section>

    <section class="section-form section-list">
      <input
        #attachmentFileInputEl
        type="file"
        multiple="false"
        [hidden]="true"
        (change)="onAttachmentFileChange()"
      />

      <ng-template
        [ngTemplateOutlet]="sectionListTpl"
        [ngTemplateOutletContext]="attachmentsSectionListContext"
      ></ng-template>
    </section>

    <section class="section-form section-list section-select-objects">
      <div class="section-list-content">
        <app-toolbar class="section-toolbar">
          <div appToolbarItemBefore class="title">SELECIONAR OBJETOS</div>

          <div
            *ngIf="!isEditMode"
            appToolbarItemAfter
            class="btn-item btn-select-objects-container"
            [appBlockModalDrag]="!(isMobileModeObservable | async)"
          >
            <app-button
              buttonType="primary"
              styleType="contained"
              sizeType="small"
              text="Selecionar área"
              (click)="onBtnSelectGeometryInMapClick()"
            >
            </app-button>
          </div>
        </app-toolbar>

        <app-select-objects-table
          [fields]="areaGridFields"
          [resultList]="areaResultListToSelect"
          [(selectedItemKeys)]="areaResultListKeysSelected"
          [keyExpr]="areaResultKeyExpr"
          [showSelectControlsEnabled]="!isEditMode"
        ></app-select-objects-table>
      </div>
    </section>
  </app-scroll-view>

  <div class="actions-bottom">
    <!-- <div
      *ngIf="isEditMode && !!(canShowBtnCancelObservable | async)"
      class="btn-item"
      [appBlockModalDrag]="!(isMobileModeObservable | async)"
    >
      <app-button
        buttonType="danger"
        styleType="contained"
        text="Cancelar"
        (click)="canceledModalVisible = true"
      ></app-button>
    </div> -->

    <!-- <div
          *ngIf="!!(canShowBtnPublishObservable | async)"
          class="btn-item"
          [appBlockModalDrag]="!(isMobileModeObservable | async)"
        >
          <app-button
            buttonType="primary"
            styleType="contained"
            text="Publicar"
            (click)="onBtnChangeStatusClick(statusMap.Notified)"
          ></app-button>
        </div> -->

    <!-- <div
      *ngIf="isEditMode && !!(canShowBtnAcceptObservable | async)"
      class="btn-item"
      [appBlockModalDrag]="!(isMobileModeObservable | async)"
    >
      <app-button
        buttonType="primary"
        styleType="contained"
        text="Aceitar"
        (click)="onBtnChangeStatusClick(statusMap.Accepted)"
      ></app-button>
    </div> -->

    <!-- <div
      *ngIf="isEditMode && !!(canShowBtnResolveObservable | async)"
      class="btn-item"
      [appBlockModalDrag]="!(isMobileModeObservable | async)"
    >
      <app-button
        buttonType="primary"
        styleType="contained"
        text="Resolver"
        (click)="onBtnChangeStatusClick(statusMap.Resolved)"
      ></app-button>
    </div> -->

    <div
      *ngIf="canSaveObservable | async"
      class="btn-item ms-auto"
      [appBlockModalDrag]="!(isMobileModeObservable | async)"
    >
      <app-button
        type="submit"
        buttonType="primary"
        styleType="contained"
        text="Gravar"
      ></app-button>
    </div>

    <div
      *ngIf="!isEditMode"
      class="btn-item"
      [appBlockModalDrag]="!(isMobileModeObservable | async)"
    >
      <app-button
        buttonType="normal"
        styleType="contained"
        text="Limpar"
        (click)="onBtnClearClick()"
      ></app-button>
    </div>
  </div>
</form>

<ng-template
  #sectionListTpl
  let-title="title"
  let-btnAddEnabled="btnAddEnabled"
  let-onAddClick="onAddClick"
  let-onDeleteClick="onDeleteClick"
  let-pageObj="pageObj"
  let-columnsCount="columnsCount"
  let-onViewClick="onViewClick"
>
  <div class="section-list-content">
    <app-toolbar class="section-toolbar">
      <div appToolbarItemBefore class="title">
        {{ title }}
      </div>

      <div
        appToolbarItemAfter
        class="btn-item"
        #btnAddItem
        [appBlockModalDrag]="!(isMobileModeObservable | async)"
      >
        <app-button
          buttonType="normal"
          styleType="text"
          sizeType="large"
          shapeType="circle"
          icon="assets/icons/circle-plus.svg"
          (click)="onAddClick?.($event)"
          [disabled]="!((canSaveObservable | async) && (btnAddEnabled ?? true))"
        >
        </app-button>

        <app-tooltip
          [target]="btnAddItem"
          verticalAlignment="center"
          horizontalAlignment="left"
        >
          Adicionar
        </app-tooltip>
      </div>
    </app-toolbar>

    <app-list
      class="list"
      [items]="pageObj.items"
      [scrollable]="false"
      keyExpr="data"
    >
      <ng-template listContainer let-itemListTemplate="itemListTemplate">
        <div class="row">
          <ng-template [ngTemplateOutlet]="itemListTemplate"></ng-template>
        </div>
      </ng-template>

      <ng-template listItem let-item="item" let-index="index">
        <div class="col-md-{{ 12 / (columnsCount ?? 1) }}">
          <div
            class="item"
            [appBlockModalDrag]="!(isMobileModeObservable | async)"
          >
            <div class="actions">
              <div class="btn-delete-item" #btnDeleteItem>
                <app-button
                  buttonType="danger"
                  styleType="text"
                  shapeType="circle"
                  icon="assets/icons/trash.svg"
                  (click)="onDeleteClick?.(item, index)"
                  [disabled]="!(canSaveObservable | async)"
                ></app-button>

                <app-tooltip
                  [target]="btnDeleteItem"
                  verticalAlignment="top"
                  horizontalAlignment="center"
                >
                  Apagar
                </app-tooltip>
              </div>

              <div
                *ngIf="onViewClick && isEditMode"
                class="btn-view-item"
                #btnViewItem
              >
                <app-button
                  buttonType="normal"
                  styleType="text"
                  shapeType="circle"
                  icon="assets/icons/view.svg"
                  (click)="onViewClick?.(item)"
                ></app-button>

                <app-tooltip
                  [target]="btnViewItem"
                  verticalAlignment="top"
                  horizontalAlignment="center"
                >
                  Vizualizar
                </app-tooltip>
              </div>
            </div>

            <div class="text">
              {{ item?.text }}
            </div>
          </div>
        </div>
      </ng-template>
    </app-list>

    <div class="pagination-container">
      <app-pagination
        [totalCount]="pageObj.totalCount"
        [pageSize]="pageObj.pageSize"
        [pageIndex]="pageObj.pageIndex"
        (pageIndexChange)="pageObj.onPageChange?.($event)"
        [appBlockModalDrag]="!(isMobileModeObservable | async)"
      ></app-pagination>
    </div>
  </div>
</ng-template>

<app-note-form
  [(visible)]="noteFormModalVisible"
  (onSaveChanges)="onNoteSave($event)"
></app-note-form>

<app-modal
  [(visible)]="canceledModalVisible"
  modalTitle="Cancelar ocorrência"
  width="30rem"
  height="auto"
  (onHidden)="descriptionCanceled = null"
>
  <ng-template modalContent>
    <div class="cancel-modal-body-content">
      <div class="field-set">
        <label label>Descrição do cancelamento</label>

        <app-text-area
          [(value)]="descriptionCanceled"
          [rows]="3"
          resize="none"
          [showErrorEnabled]="false"
        ></app-text-area>
      </div>

      <div class="actions-bottom">
        <app-button
          buttonType="normal"
          styleType="contained"
          text="Não"
          (click)="canceledModalVisible = false"
        ></app-button>
        <app-button
          buttonType="danger"
          styleType="contained"
          text="Sim"
          (click)="onBtnChangeStatusClick(statusMap.Canceled)"
        ></app-button>
      </div>
    </div>
  </ng-template>
</app-modal>
